export enum PeriodicityTypeEnum {
  MONTHLY = 'Mensal',
  QUARTERLY = 'Trimestral',
  SEMIANNUAL = 'Semestral',
  ANNUAL = 'Anual',
}